import { render, staticRenderFns } from "./RedeliveryRequestList.vue?vue&type=template&id=6b701eb0&scoped=true&"
import script from "./RedeliveryRequestList.vue?vue&type=script&lang=js&"
export * from "./RedeliveryRequestList.vue?vue&type=script&lang=js&"
import style0 from "./RedeliveryRequestList.vue?vue&type=style&index=0&id=6b701eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b701eb0",
  null
  
)

export default component.exports